var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.17,
    height: 31.17,
    viewBox: "0 0 31.17 31.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ppt",
    transform: "translate(-3698.359 -1912.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1214",
    "data-name": "Group 1214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M3729.529,1922.357v17.39a4.421,4.421,0,0,1-4.42,4.42h-22.33a4.422,4.422,0,0,1-4.42-4.42v-22.33a4.422,4.422,0,0,1,4.42-4.42h17.39Z",
    fill: "#ef5b3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M3720.169,1917.937V1913l9.36,9.36h-4.94A4.422,4.422,0,0,1,3720.169,1917.937Z",
    fill: "#f48874"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1215",
    "data-name": "Group 1215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M3704.636,1926.049h1.85c.233,0,.489.011.767.031a4.382,4.382,0,0,1,.836.15,3.159,3.159,0,0,1,.807.361,2.449,2.449,0,0,1,.689.661,3.392,3.392,0,0,1,.482,1.046,5.531,5.531,0,0,1,.182,1.528v.429a7.238,7.238,0,0,1-.167,1.675,4.321,4.321,0,0,1-.447,1.172,2.629,2.629,0,0,1-.646.76,2.86,2.86,0,0,1-.764.432,3.373,3.373,0,0,1-.8.192,6.456,6.456,0,0,1-.761.047h-.178v3.714h-1.85Zm1.942,7.127a2.137,2.137,0,0,0,.843-.147,1.191,1.191,0,0,0,.547-.457,2.176,2.176,0,0,0,.293-.8,6.682,6.682,0,0,0,.089-1.174v-1.1a4.837,4.837,0,0,0-.079-.939,1.506,1.506,0,0,0-.282-.654,1.209,1.209,0,0,0-.546-.382,2.566,2.566,0,0,0-.865-.125h-.092v5.778Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M3711.65,1926.049h1.849c.234,0,.49.011.768.031a4.383,4.383,0,0,1,.836.15,3.185,3.185,0,0,1,.807.361,2.466,2.466,0,0,1,.689.661,3.4,3.4,0,0,1,.482,1.046,5.579,5.579,0,0,1,.182,1.528v.429a7.292,7.292,0,0,1-.167,1.675,4.353,4.353,0,0,1-.447,1.172,2.64,2.64,0,0,1-.646.76,2.871,2.871,0,0,1-.764.432,3.378,3.378,0,0,1-.8.192,6.44,6.44,0,0,1-.76.047h-.179v3.714h-1.849Zm1.942,7.127a2.142,2.142,0,0,0,.843-.147,1.188,1.188,0,0,0,.546-.457,2.137,2.137,0,0,0,.293-.8,6.58,6.58,0,0,0,.09-1.174v-1.1a4.915,4.915,0,0,0-.079-.939,1.518,1.518,0,0,0-.282-.654,1.205,1.205,0,0,0-.547-.382,2.555,2.555,0,0,0-.864-.125h-.093v5.778Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M3719.791,1927.505h-1.964v-1.456h5.771v1.456h-1.957v10.742h-1.85Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.11f343bc2a0ac5b1e9dcf23f7bb8243a.svg";
export { ForwardRef as ReactComponent };